
<template>
  <HomeScreen />
</template>


<script>
  // @ is an alias to /src
  import { mapGetters, mapActions } from 'vuex'
  import HomeScreen from '@/components/HomeScreen.vue'
  
  export default {
    name: 'Home',

    components: {
      HomeScreen
    },

    methods: {
      ...mapActions({

      }),
      
      ...mapGetters({

      }),

    },

    mounted () {
    }
  };
</script>
